import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { db } from "helpers/firebase/firebaseConfig";
import { onSnapshot, collection } from "firebase/firestore";
import * as providerActions from "../../store/actions";

const ServiceProviderSub = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Subscribe to service_providers collection changes
    const unsubscribe = onSnapshot(
      collection(db, "service_providers"),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            handleCreateEvent();
          } else if (change.type === "modified") {
            handleUpdateEvent();
          }
          // You can also handle "removed" if needed
        });
      },
      (error) => {
        console.error("Service providers subscription error:", error);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [dispatch]);

  const handleCreateEvent = () => {
    dispatch(providerActions.fetchServiceProvidersRequest());
  };

  const handleUpdateEvent = () => {
    dispatch(providerActions.fetchServiceProvidersRequest());
  };

  return null; // This component doesn't render anything
};

export default ServiceProviderSub;